// src/components/PaymentModal.js
import React, { useEffect } from 'react';
import PaymentForm from './PaymentForm';
import './PaymentForm.css';

const PaymentModal = ({ isOpen, onClose, listingId, price, userId, listerEmail, remainingCapacity = null, onPaymentSuccess, onPaymentError }) => {
  // Prevent scrolling on the body when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Close modal when clicking outside the content
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="payment-modal-overlay" onClick={handleOverlayClick}>
      <div className="payment-modal-content">
        <button 
          className="payment-modal-close" 
          onClick={onClose}
          aria-label="Close payment modal"
        >
          ×
        </button>
        
        <PaymentForm 
          listingId={listingId}
          price={price}
          userId={userId}
          listerEmail={listerEmail} // Pass lister email to PaymentForm
          remainingCapacity={remainingCapacity}
          onPaymentSuccess={(paymentIntent) => {
            onPaymentSuccess(paymentIntent);
            onClose();
          }}
          onPaymentError={onPaymentError}
        />
      </div>
    </div>
  );
};

export default PaymentModal;
